module.exports = __webpack_public_path__ + "img/企业信用等级.7a7d7e5b.svg";